import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Form = memo(({ children, className, onSubmit }) => (
  <form className={className} onSubmit={onSubmit}>
    {children}
  </form>
))

Form.defaultProps = {
  className: '',
  onSubmit: () => {}
}

Form.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string, 
  onSubmit: PropTypes.instanceOf(Function)
}

Form.FormGroup = memo(({ children, className }) => (
  <div className={`form-group ${className}`}>
    {children}
  </div>
))

Form.FormGroup.defaultProps = {
  className: ''
}

Form.FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

Form.InputGroup = memo(({ children, className, label, helperMessage }) => (
  <div className={`input-group ${className}`}>
    {label && <label className="flex items-end space-x-1"><span>{label}</span>{helperMessage}</label>}
    {children}
  </div>
))

Form.InputGroup.defaultProps = {
  className: '',
  label: '',
  helperMessage: null
}

Form.InputGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  helperMessage: PropTypes.object
}

export default Form